import { MobileSwitch } from '@/components/ui'
import React from 'react'
import { twMerge } from 'tailwind-merge'

import InfoContainter from './info_container'
import ResourceMessage from './resource_registration'

interface AuthenticationLayoutProps
  extends React.HTMLAttributes<HTMLDivElement> {
  showResourceMessage?: boolean
}

function AuthenticationLayout({
  children,
  showResourceMessage = false,
}: AuthenticationLayoutProps) {
  return (
    <MobileSwitch
      regularClassName="h-screen"
      regularView={
        <div className="flex w-full h-full">
          <div
            className={twMerge(
              'flex flex-col w-[60%] items-center gap-8',
              showResourceMessage ? 'justify-start pt-16' : 'justify-center',
            )}
          >
            {showResourceMessage && <ResourceMessage />}
            {children}
          </div>
          <div className="flex w-[40%] p-2">
            <InfoContainter />
          </div>
        </div>
      }
      mobileView={
        <div className="flex flex-col gap-8 items-center px-1 pt-12 w-full">
          {showResourceMessage && <ResourceMessage isMobileView />}
          {children}
          <InfoContainter isMobileView />
        </div>
      }
    />
  )
}

export default AuthenticationLayout
